import {
  Box,
  Card,
  Group,
  Modal,
  Badge,
  Divider,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";

interface VisitSummaryModalProps {
  opened: boolean;
  onClose: () => void;
}

const VisitSummaryModal: React.FC<VisitSummaryModalProps> = ({
  opened,
  onClose,
}) => {
  const theme = useMantineTheme();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="70%"
      radius="md"
      title="Visit Summary"
      withCloseButton={true}
    >
      <Box
        bg={`linear-gradient(90deg, ${theme.colors.orange[1]} 0%, ${theme.colors.indigo[1]} 100%)`}
      >
        <Box mt={0} p={"md"}>
          <Text fw={500} size="sm" >
            Needs to Be Discussed with Doctor
          </Text>

          <Box p="md">
            {/*  #4 */}
            <Card 
              p="md" 
              mb="md" 
              radius="md" 
              style={{
                border: "1px solid #1662B3",
                backgroundColor: "#1662B3",
                color: "white",
              }}
            >
              <Group align="flex-start" mb="sm">
                <Text size="md" fw={600} c="white">
                  #4: Eat a Kidney-Friendly, Heart-Healthy Diet
                </Text>
                <Badge color="white" variant="filled" size="sm" style={{ color: "#1662B3" }}>
                  Provider Alert
                </Badge>
              </Group>
              <Box p={"sm"}>
                <Text fw={500} size="sm" mb="xs" c="white">
                  Summary:
                </Text>
                <Stack gap="xs">
                  <Text size="sm" c="white">
                    • Explain food choices that support kidney and heart health.
                  </Text>
                  <Text size="sm" c="white">• Recommend portion control strategies.</Text>
                  <Text size="sm" c="white">
                    • Review fluid intake recommendations if relevant.
                  </Text>
                </Stack>
              </Box>
            </Card>

            {/*  #6 */}
            <Card 
              p="md" 
              radius="md" 
              style={{
                border: "1px solid #1662B3",
                backgroundColor: "#1662B3",
                color: "white",
              }}
            >
              <Group align="flex-start" mb="sm">
                <Text size="md" fw={600} c="white">
                  #6: Monitor for Kidney Symptoms
                </Text>
                <Badge color="white" variant="filled" size="sm" style={{ color: "#1662B3" }}>
                  Provider Alert
                </Badge>
              </Group>
              <Box p={"sm"}>
                <Text fw={500} size="sm" mb="xs" c="white">
                  Summary:
                </Text>
                <Stack gap="xs">
                  <Text size="sm" c="white">
                    • Discuss when to call the provider vs. seek urgent care.
                  </Text>
                  <Text size="sm" c="white">
                    • Consider lab tests for kidney function monitoring.
                  </Text>
                  <Text size="sm" c="white">
                    • Review warning signs (e.g., swelling, changes in urine).
                  </Text>
                </Stack>
              </Box>
            </Card>
            <Text mt="sm" c="white">Other</Text>
            <Card 
              p="md" 
              mb="md" 
              radius="md" 
              style={{
                border: "1px solid #1662B3",
                backgroundColor: "#1662B3",
                color: "white",
              }}
            >
              <Text size="md" fw={600} c="white">
                #1: Track Your Blood Pressure at Home
              </Text>
              <Box p={"sm"}>
                <Text fw={500} size="sm" mb="xs" c="white">
                  Summary:
                </Text>
                <Stack gap="xs">
                  <Text size="sm" c="white">
                    • Confirm the correct technique for using a BP monitor.
                  </Text>
                  <Text size="sm" c="white">
                    • Discuss ideal frequency and target BP ranges.
                  </Text>
                </Stack>
              </Box>
            </Card>

            <Card 
              p="md" 
              radius="md" 
              style={{
                border: "1px solid #1662B3",
                backgroundColor: "#1662B3",
                color: "white",
              }}
            >
              <Text size="md" fw={600} c="white">
                #2: Take Medications as Prescribed
              </Text>
              <Box p={"sm"}>
                <Text fw={500} size="sm" mb="xs" c="white">
                  Summary:
                </Text>
                <Stack gap="xs">
                  <Text size="sm" c="white">
                    • Explain food choices that support kidney and heart health.
                  </Text>
                  <Text size="sm" c="white">• Recommend portion control strategies.</Text>
                </Stack>
              </Box>
            </Card>
          </Box>
        </Box>

        <Divider />
      </Box>
    </Modal>
  );
};

export default VisitSummaryModal;
